<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <template v-slot:activator="{ on }">
        <v-btn color="primary" dark v-on="on">Open gallery</v-btn>
      </template>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="dialog = false">
            <v-icon>fa-times</v-icon>
          </v-btn>
          <v-toolbar-title>Gallery</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click="dialog = false">Close</v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-divider></v-divider>

        <v-card>
          <v-card-actions>
            <v-text-field
              :disabled="uploadLoading"
              :loading="uploadLoading"
              label="Upload image"
              type="file"
              ref="file"
              @input="uploadImage"
            />
            <v-spacer></v-spacer>
          </v-card-actions>
          <div v-if="loading" class="text-xs-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
          <v-item-group mandatory v-model="selectedItem">
            <v-container grid-list-xl fluid>
              <v-layout row wrap>
                <v-flex v-for="(file, i) of files" :key="i" xs3>
                  <v-item>
                    <v-card
                      flat
                      tile
                      slot-scope="{ active, toggle }"
                      class="elevation-2"
                      @click="toggle"
                    >
                      <v-img :src="file" contain>
                        <div
                          class="fill-height"
                          :class="{ 'repeating-gradient': active }"
                        ></div>
                        <template v-slot:placeholder>
                          <v-layout
                            fill-height
                            align-center
                            justify-center
                            ma-0
                          >
                            <v-progress-circular
                              indeterminate
                              color="primary"
                            ></v-progress-circular>
                          </v-layout>
                        </template>
                      </v-img>
                    </v-card>
                  </v-item>
                </v-flex>
              </v-layout>
            </v-container>
          </v-item-group>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import uuid from "uuid/v4";
import { storage } from "../plugins/firebase";
import { eventHub } from "../config/constants";

export default {
  props: {
    value: String,
    type: String
  },
  data: () => ({
    uploadLoading: false,
    dialog: false,
    files: [],
    loading: false,
    selectedItem: -1
  }),
  methods: {
    async listImages(ref) {
      this.loading = true;
      const result = await ref.listAll();
      const images = (await Promise.all(
        result.items.map(item =>
          item.getMetadata().then(fileMetadata => [item, fileMetadata])
        )
      ))
        .filter(([, fileMetadata]) =>
          ["octet-stream", "jpeg", "png"].includes(
            fileMetadata.contentType.split("/")[1]
          )
        )
        .map(([image]) => image);
      const imagesUrls = await Promise.all(
        images.map(item => item.getDownloadURL())
      );
      if (imagesUrls.length) {
        this.files.push(...imagesUrls);
      }
      if (result.prefixes.length) {
        await Promise.all(
          result.prefixes.map(prefix => this.listImages(prefix))
        );
      }
      this.loading = false;
    },
    async uploadImage() {
      this.uploadLoading = true;
      try {
        const files = this.$refs.file.$refs.input.files;
        if (files.length) {
          const upload = await storage
            .ref()
            .child(`${this.type}/images/${uuid()}`)
            .put(files[0]);
          const imageUrl = await upload.ref.getDownloadURL();
          this.files.push(imageUrl);
          this.$nextTick(() => {
            this.selectedItem = this.files.indexOf(imageUrl);
            eventHub.$emit("message", "green");
          });
        }
      } catch (error) {
        eventHub.$emit("message", "red", error.message);
      }
      this.uploadLoading = false;
    }
  },
  watch: {
    dialog(isOpen) {
      if (isOpen && !this.files.length) {
        this.listImages(storage.ref());
      }
    },
    files(files) {
      const index = files.findIndex(file => file === this.value);
      if (index >= 0) {
        this.selectedItem = index;
      }
    },
    selectedItem(selectedItem) {
      const file = this.files[selectedItem];
      if (file !== this.value) {
        this.$emit("input", file);
        this.dialog = false;
      }
    }
  }
};
</script>

<style lang="sass" scoped>
.repeating-gradient
  background-image: repeating-linear-gradient(-45deg, rgba(134, 200, 64, .45), rgba(134, 200, 64, .45) 5px, rgba(226, 226, 226,.25) 5px, rgba(226, 226, 226,.25) 10px)
</style>
